import type { ButtonHTMLAttributes } from 'react';
import { Button as MoonButton } from '@heathmont/moon-components';
import styled from 'styled-components';

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  isBitcasino: boolean;
  variant: 'primary';
};

const PrimaryButton = styled(MoonButton)<Props>`
  && {
    ${({ theme, isBitcasino }) =>
      isBitcasino && `color: ${theme.color.goku[100]};`}
  }
`;

export default PrimaryButton;
